/* eslint-disable max-lines */
import { gql } from "apollo-boost"

export const getById = gql`
  query SubmissionById($id: ID!) {
    Submission(id: $id) {
      id
      implementer {
        id
        name
        email
        phone
        vision
        mission
        director
        previousSupports
        commercialAddress
        legalRepresentative
        institutionalExperience
        councilMembers {
          name
          charge
        }
      }
      BlockingProjectDetails
      BlockingImplementationLocations
      BlockingConsultants
      BlockingDocuments
      BlockingDevelopmentObjective
      name
      type
      applyingCall
      township
      region
      allies
      alliedOne
      alliedTwo
      implementationPlace
      responsible
      startDate
      endDate
      strategicAxis
      preventionLevel
      scope
      issueDescription
      description
      justification
      developmentObjective
      generalObjective
      specificObjectives {
        id
        description
        orderIndex
        indicators {
          id
          isBlocking
          type
          title
          orderIndex
          description
          methodology
          formula
          meansOfVerification
          baseline
          goal
          startDate
          endDate
          measurementPeriodicity
          products
        }
        activities {
          id
          isBlocking
          title
          orderIndex
          description
          responsible
          methodology
          formula
          meansOfVerification
          baseline
          goal
          place
          months
          inputs
          products
          schedules {
            id
            place
            scheduledAt
            completedAt
            startTime
            endTime
          }
        }
      }
      beneficiaries {
        id
        isBlocking
        name
        description
        number
        gender
        educationLevel
        beneficiaryIndex
        age
        preventionLevel
      }
      consultants {
        id
        isBlocking
        description
        commercialName
        commercialAddress
        contactName
        phone
        rfc
        fiscalAddress
        fiscalPersonType
        hadReceivedSupports
        supports {
          id
          name
          receivedAt
          amount
        }
        documents {
          id
          name
          url
        }
      }
      developmentObjectiveIndicators {
        id
        type
        title
        description
        methodology
        formula
        meansOfVerification
        baseline
        goal
        startDate
        endDate
        measurementPeriodicity
        products
      }
      generalObjectiveIndicators {
        id
        type
        title
        description
        methodology
        formula
        meansOfVerification
        baseline
        goal
        startDate
        endDate
        measurementPeriodicity
        products
      }
      concepts {
        id
        name
        region
        type
        measurementUnit
        unitCost
        totalUnits
        monthlyDistribution
        monthlyDistributionHours
        budgeted
        investmentDistribution {
          id
          name
          type
          percentage
        }
        humanResource {
          id
          position
          name          
          hours
          contractType
          salary
          benefits          
          documents {
          id
          name
          url
          type
        }
        positionDocs {
          id
          name
          url
          type
        }
        }
      }
      state
      status
      statusChangedAt
      deadline
      signedContractAt
      agreementNumber
      technicalOpinion
      documents {
        id
        name
        type
        url
      }
      budgeted
      evidenced
      difference
      invoices {
        id
        uuid
        issuer
        rfc
        issuedAt
        receptor
        monthAt
        reviewed
        concept
        category
        paymentAt
        ficosecPayment
        investmentOnePayment
        investmentTwoPayment
        implementerPayment
        amount
        percentage
        typeRH
        documents {
          id
          type
          name
          url
        }
      }
      technicalMonitoringReports{
        id
        key
        goal
        appliedAt
        completed
        compliance
        reviewedAt
        verificationDocuments{
          id
          name
          url
        }
        participants{
          id
          amount
          type
          age
          gender
          preventionLevel
        }
      }
      technicalUpdates{
        id
        correctiveActions
        challenges
        obstacles
        createdAt
      }
      closureDescription
      closureDocuments{
        id
        url
        name
      }
      createdAt
      assistants{
        id
        folio
        name
        lastName
        maidenName
        gender
        birthdate
        curp
        phone
        state
        municipality
        colony
        beneficiary
        assistance{
          id
          assistanceAt
          activity {
            id
            description
          }
        }
      }
      projectBeneficiaries{
        id
        folio
        name
        lastName
        maidenName
        gender
        birthdate
        curp
        phone
        state
        municipality
        colony
        projectAssistantId
      }
    }
  }
`
